export function MessageForm(props) {
  
  const { formRequestStatus, hasProcessingInformation } = props;

  return (
    <div>
      {formRequestStatus.typeAlert.length !== 0 &&
        hasProcessingInformation === false && (
          <div
            className={`alert ${formRequestStatus.typeAlert} text-center fs-6`}
            role="alert"
            style={{ padding: "7px" }}
          >
            {formRequestStatus.message}
          </div>
        )}
      {hasProcessingInformation === true && (
        <div className="text-light text-center">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div className="text-light text-center">
            Por favor, aguarde enquanto
            <br />
            Processamos suas informações.
          </div>
        </div>
      )}
    </div>
  );
}
